export default __webpack_public_path__ + "static/media/filters.71060c49.svg";